export default {
    props: {
        chartAreaBackground: {
            type: String,
            kComposite: 'chartArea.background'
        }, 
        chartAreaBorderColor: {
            type: String,
            kComposite: 'chartArea.border.color'
        }, 
        chartAreaBorderDashType: {
            type: String,
            kComposite: 'chartArea.border.dashType'
        }, 
        chartAreaBorderWidth: {
            type: Number,
            kComposite: 'chartArea.border.width'
        }, 
        chartAreaHeight: {
            type: Number,
            kComposite: 'chartArea.height'
        }, 
        chartAreaMargin: {
            type: Number,
            kComposite: 'chartArea.margin'
        }, 
        chartAreaMarginBottom: {
            type: Number,
            kComposite: 'chartArea.margin.bottom'
        }, 
        chartAreaMarginLeft: {
            type: Number,
            kComposite: 'chartArea.margin.left'
        }, 
        chartAreaMarginRight: {
            type: Number,
            kComposite: 'chartArea.margin.right'
        }, 
        chartAreaMarginTop: {
            type: Number,
            kComposite: 'chartArea.margin.top'
        }, 
        chartAreaOpacity: {
            type: Number,
            kComposite: 'chartArea.opacity'
        }, 
        chartAreaWidth: {
            type: Number,
            kComposite: 'chartArea.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ChartArea.js